<template>
	<div style="background-color: rgb(245, 245, 245);color: #000;font-weight: 900;">
		<div style="padding: 20px;border-bottom: 1px solid #ccc;font-size: 28px;">			
			<span >数据生成和案例总结</span>
		</div>

		
		<div >
			<div class="panel" style="background-color: rgb(245, 245, 245);">
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<div style="padding:  0 20px;">
							<div>
								测量示例：
							</div>
							<div style="display: flex;">
								<div style="margin-top: 20px; padding: 0; width: 50%;text-align: center;border:1px solid #ccc">
									<img  style="width: 80%;" :src="'https://bikecdn.typhcl.cn/tool/img/fitting/3.png'" />
								</div>
								<div style="margin-top: 20px; padding: 0; width: 50%;text-align: center;border:1px solid #ccc">
									<img  style="width: 80%;" :src="'https://bikecdn.typhcl.cn/tool/img/fitting/4.png'" />
								</div>
								
							</div>
							<div style="display: flex;">
								<div style="margin-top: 20px; padding: 0; text-align: center;flex: 1;border:1px solid #ccc">
									<img  style="width: 80%;" :src="'https://bikecdn.typhcl.cn/tool/img/fitting/5.png'" />
								</div>
								<div style="margin-top: 20px; padding: 0; text-align: center;flex: 1;border:1px solid #ccc">
									<img  style="width: 80%;" :src="'https://bikecdn.typhcl.cn/tool/img/fitting/6.png'" />
								</div>
								<div style="margin-top: 20px; padding: 0; text-align: center;flex: 1;border:1px solid #ccc">
									<img  style="width: 80%;" :src="'https://bikecdn.typhcl.cn/tool/img/fitting/7.png'" />
								</div>
							</div>
							</div>
						
						
						
						<div v-for="(item, index) in set_bf" :key="index">
							
							<div class="row cl">
								<label class="form-label col-xs-4 col-sm-2">{{item[0]}}</label>
								<div class="formControls col-xs-8 col-sm-9">
									<input style="width: 400px;" :placeholder="item[0]" v-model="item[2]" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
							</div>
							
												
						</div>	
						<div class="row cl">
							<label class="form-label col-xs-4 col-sm-2">案例总结</label>
							<div class="formControls col-xs-8 col-sm-9">
								<textarea v-model="cl_bz" style="width: 300px; height: 200px; background-color: #fff; border: 1px solid #fff; color: #000; font-size: 16px;" placeholder="案例总结."></textarea>
							</div>
						</div>
						
						
						<div class="row cl">
							<div class="col-xs-8 col-sm-9 col-xs-offset-4 col-sm-offset-3">							
								<input class="btn btn-primary radius ml-10" type="button" @click="next()" value="下一步">			
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'fcl', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				// 在这里定义你的组件数据
				cl_bz:"",
				sta: 3,
				set_bf: [
					["坐垫高度[毫米]", "", ""],
					["有效坐垫后移量[毫米]", "", ""],
					["手变Reach[毫米]", "", ""],
					["手变Stack[毫米]", "", ""],
					["把立长度[毫米]", "", ""],
					["把立角度[度数]", "", ""],
					["垫圈[简要描述]", "", ""],
					["弯把Reach[毫米]", "", ""],
					["上把位宽度[毫米]", "", ""],
					["坐垫信息[简要描述]", "", ""],
					["坐垫角度[度数]", "", ""],
					["曲柄长度[毫米]", "", ""],
					["座管信息[简要描述]", "", ""],
					["锁鞋信息[简要描述]", "", ""],
					["锁片旋转[度数]", "", ""],
					["锁鞋垫片[简要描述]", "", ""],
					["鞋垫[简要描述]", "", ""],
					["脚踏[简要描述]", "", ""]
				],
				img_h: 'https://bikecdn.typhcl.cn/tool/cls/',
				f_h: 'https://bikecdn.typhcl.cn/tool/cls/',
				src: "",
				list: [],
				
				main: {
					name: ""
				},
				dat: [],
				sc_bz: "",

				cl_bz: "",
				id:0
			
			};
		},
		computed: {
			// 计算属性
		},
		methods: {

			floats(dat, f) {
				return dat.toFixed(f);
			},
			next() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "save_send_bg",
						token: localStorage.getItem('token'),
						id: that.$data.id,								
						dat:JSON.stringify(that.$data.set_bf), 
						bz:that.$data.cl_bz
					},
					dataType: "json",
					success(e) {
						that.$router.replace('/edit?id=' + that.$data.id);
					}
				})
			},
			start_fitting() {
				$.ajax({
					url: that.URL,
					data: {
						t: "start_f",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.$router.replace('/fcl?id=' + e.fid);
					}
				})
			},
			init() {
				var that = this
				
				$.ajax({
					url: that.URL,
					data: {
						t: "msg_init",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						that.$data.main = e.main;
					}
				})
				$.ajax({
					url: that.URL,
					data: {
						t: "finish_init",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.set_bf=e.list;
					}
				})
			}
		},
		mounted() {
			var that = this
			that.$data.id = this.$route.query.id;
			// 组件挂载后执行的代码
			that.init()
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}

	.form-label {
		text-align: left !important;
		
		padding-left: 40px;
	}
</style>